import React from "react";

import { Typography } from "@braintrust/braintrust-ui-components";
import type { StripeCreditCardPayment } from "@js/types/payments";

import { PaymentMethodMaskedNumber } from "../../masked-credit-card-number";

import styles from "../style.module.scss";

type StripeCCItemProps = {
  paymentMethod: StripeCreditCardPayment;
};

export const StripeCCItem = ({ paymentMethod }: StripeCCItemProps) => (
  <>
    <div className={styles.paymentMethodsListItemDetailsItem}>
      <Typography
        component="p"
        size="small"
        fontWeight={500}
        color="grey-2"
        className={styles.paymentMethodsListItemDetailsItemName}
        sx={{ textTransform: "uppercase" }}
      >
        Card Number
      </Typography>
      <Typography component="p">
        <PaymentMethodMaskedNumber last4={paymentMethod.method.last4} />
      </Typography>
    </div>
    {paymentMethod.method.exp_month && paymentMethod.method.exp_year && (
      <div className={styles.paymentMethodsListItemDetailsItem}>
        <Typography
          component="p"
          size="small"
          fontWeight={500}
          color="grey-2"
          className={styles.paymentMethodsListItemDetailsItemName}
          sx={{ textTransform: "uppercase" }}
        >
          Expiry Date
        </Typography>
        <Typography component="p">
          {paymentMethod.method.exp_month}/{paymentMethod.method.exp_year}
        </Typography>
      </div>
    )}
  </>
);
